(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kontraband-header"]) return;
  try {
    
jQuery(document).ready(function (e) {
    const a = document.getElementById("footerDate");
    if (null !== a) {
        const e = new Date();
        a.textContent = e.getFullYear();
    }
    var o;
    e(".hamburger-wrap").click(function () {
        e(this).toggleClass("active"), e("body").toggleClass("menu-open");
    });
    var d = 0,
        r = 5,
        t = e("header").outerHeight();
    e(window).scroll(function (e) {
        o = !0;
    }),
        setInterval(function () {
            o &&
                (!(function () {
                    var a = e(this).scrollTop();
                    if (Math.abs(d - a) <= r) return;
                    a > d && a > t
                        ? (e("header").removeClass("header-down").addClass("header-up"), e(".artistlogo").removeClass("header-down").addClass("header-up"), e(".hamburger-wrap").removeClass("header-down").addClass("header-up"))
                        : a + e(window).height() < e(document).height() &&
                          (e("header").removeClass("header-up").addClass("header-down"), e(".artistlogo").removeClass("header-up").addClass("header-down"), e(".hamburger-wrap").removeClass("header-up").addClass("header-down"));
                    d = a;
                })(),
                (o = !1));
        }, 250);
}),
(window.releasesLayout1Loaded = function () {}),
(window.bioLayout1Loaded = function () {}),
(window.contactLayout1Loaded = function () {});


  } catch(e) { console.error(e); }
})();
})();
